export default [
    {
        path: '/agent',
        name: 'AgentDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../../views/agent/Dashboard.vue')
    },
]